module.exports = __webpack_public_path__ + "static/media/ToyotaType-Bold.7d6db386.otf";